/** Конфиг клиента. Публичные значения — не секреты (K8: секреты только серверно). */

/** База API: та же origin за nginx; в vite-dev — прокси /api. */
export const API_BASE = "/api/v1";

/** Username бота для Telegram Login Widget (без @). Dev — тестовый бот. */
export const TG_BOT_NAME: string =
  (import.meta.env.VITE_TG_BOT_NAME as string | undefined) ?? "";

/** Интервал polling-фолбэка (сек), когда SSE недоступен (спека §4.3). */
export const POLL_INTERVAL_S = 4;
